import {
  ThemedButton,
  Card,
  CardHeader,
  CardContent,
  Grid,
  EnabledList,
  Link,
  Price,
  Stack,
  Typography,
  StripeForm,
} from '../../../../components'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

const STRIPE_API = `${
  (window as any)?._env_?.REACT_APP_STRIPE_API !== undefined
    ? (window as any)?._env_?.REACT_APP_STRIPE_API
    : process.env.REACT_APP_STRIPE_API
}`

const stripePromise = loadStripe(STRIPE_API)

export const Invoice = ({
  handleNext,
  policyData,
  isLoading,
  clientSecret,
  paymentData,
}) => {
  const appearance: any = {
    theme: 'none',
    variables: {
      spacingGridRow: '28px',
      spacingGridColumn: '28px',
      borderRadius: '8px',
      colorText: '#6F6E89',
      colorPrimary: '#5029Ef',
    },
    rules: {
      '.Input': {
        border: '2px solid #EAF0FE',
      },
      '.Input--invalid': {
        borderColor: '#f14949',
      },
      '.Input:focus-visible': {
        borderColor: '#5029ef',
      },
      '.Input:hover': {
        borderColor: '#5029ef',
      },
      '.Label': {
        marginLeft: '12px',
      },
      '.Error': {
        color: '#f14949',
        fontSize: '12px',
      },
    },
  }
  const options = {
    clientSecret,
    appearance,
  }
  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'stretch',
      }}
    >
      <Grid
        item
        xs={12}
        md={5}
        sx={{ height: '100%', justifyContent: 'center' }}
      >
        <Stack>
          <Typography
            variant="bodyXLarge"
            sx={{ fontWeight: 'medium', marginBottom: '2rem' }}
          >
            Policy Quote
          </Typography>
          {!isLoading && (
            <>
              <Typography
                component="h2"
                variant="bodyMedium"
                sx={{
                  marginBottom: '0.4rem',
                  color: 'primary.main',
                  fontWeight: 'medium',
                }}
              >
                {policyData?.quote_limit >= 1000000
                  ? `$${String(policyData?.quote_limit).charAt(
                      0
                    )}M Policy Limit Quote`
                  : `$${String(policyData?.quote_limit).charAt(
                      0
                    )}00K Policy Limit Quote`}
              </Typography>
              <Grid container sx={{ justifyContent: 'space-between' }}>
                <Grid item>
                  <Stack spacing="2.8rem">
                    {paymentData?.gross_amount && (
                      <Price
                        amount={
                          paymentData?.gross_amount +
                          paymentData?.details?.stripe_fee
                        }
                        term="year"
                      />
                    )}
                    {policyData?.urls?.quotes && (
                      <Link href={policyData?.urls?.quotes?.url} download>
                        <ThemedButton variant="outlined" size="small">
                          View & Download Quote
                        </ThemedButton>
                      </Link>
                    )}
                  </Stack>
                </Grid>
              </Grid>
              <Typography
                component="p"
                variant="bodyMedium"
                sx={{ marginTop: '5.6rem' }}
              >
                What’s next?
              </Typography>
              <EnabledList
                data={[
                  {
                    enabled: true,
                    enabledText: (
                      <Link
                        variant="bodySmall"
                        target="_blank"
                        download
                        href={policyData?.urls?.scan_result?.url}
                      >
                        Review your Elpha Security Scan results
                      </Link>
                    ),
                    disabledText: '',
                  },
                  {
                    enabled: true,
                    enabledText: (
                      <>
                        <Link
                          variant="bodySmall"
                          download
                          target="_blank"
                          href={policyData?.urls?.quotes.url}
                        >
                          Review your policy quote
                        </Link>
                        <Typography
                          variant="bodySmall"
                          sx={{ color: 'primary.400' }}
                        >
                          {' '}
                          and share with your client
                        </Typography>
                      </>
                    ),
                    disabledText: '',
                  },
                  {
                    enabled: true,
                    enabledText: (
                      <>
                        <Typography
                          variant="bodySmall"
                          sx={{ color: 'primary.400' }}
                        >
                          Pay for your policy
                        </Typography>
                      </>
                    ),
                    disabledText: '',
                  },
                ]}
              />
            </>
          )}
        </Stack>
      </Grid>
      <Grid item xs={12} md={7}>
        <Card>
          <CardHeader
            sx={{
              paddingTop: '4.0rem',
              paddingX: '4.0rem',
            }}
            title={
              <Typography
                variant="headlineMedium"
                component="h3"
                sx={{ color: 'primary.500', marginBottom: '0.4rem' }}
              >
                Pay for your policy
              </Typography>
            }
            subheader={
              <Typography variant="bodySmall" sx={{ color: 'primary.400' }}>
                Once payment is complete, your cyber insurance policy is
                automatically activated and you’ll receive an invite to your
                cybersecurity dashboard.
              </Typography>
            }
          />
          <CardContent>
            {!isLoading && (
              <Elements stripe={stripePromise} options={options}>
                <StripeForm
                  handleNext={handleNext}
                  clientSecret={clientSecret}
                />
              </Elements>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}
